import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, Tabs } from "antd";

// IMAGES
import uiux from "../../img/uiux.png";
import website from "../../img/website.png";
import app from "../../img/app.png";
import system from "../../img/system.png";

function OurWork() {
    const { TabPane } = Tabs;
    return (
        <div className="ourWork">
            <div className="custom-container">
                <div className="title">
                    <h1>Our Work</h1>

                    <div className="ourWork__tab-wrapper ourWork--pc">
                        <Tabs defaultActiveKey="1" tabPosition="left">
                            <TabPane
                                tab={
                                    <div className="tab-title">
                                        <span>UI/UX DESIGN</span>
                                    </div>
                                }
                                key="1"
                            >
                                <div className="service__item-content">
                                    <Row gutter={[32, 32]}>
                                        <Col
                                            xs={{ span: 24 }}
                                            md={{ span: 14 }}
                                        >
                                            <div className="service__item-content__left">
                                                <div className="">
                                                    <h2>
                                                        MOOKSHYA SEARCH ENGINE
                                                    </h2>
                                                    <p>
                                                        ke taking part in
                                                        challenges where each
                                                        rider has a different
                                                        level and riding on a
                                                        different terrain. So
                                                        you are competing
                                                    </p>
                                                    <Link
                                                        href=""
                                                        to={"/"}
                                                        className="hover-e1"
                                                    >
                                                        <span className="border-left"></span>
                                                        <span className="border-right"></span>
                                                        <span className="border-top"></span>
                                                        <span className="border-bottom"></span>
                                                        Learn More
                                                    </Link>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col
                                            xs={{ span: 24 }}
                                            md={{ span: 10 }}
                                        >
                                            <div className="service__item-content__right">
                                                <img src={uiux} alt="" />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </TabPane>
                            <TabPane
                                tab={
                                    <div className="title">
                                        <span>WEBSITE</span>
                                    </div>
                                }
                                key="2"
                            >
                                <div className="service__item-content">
                                    <Row gutter={[32, 32]}>
                                        <Col
                                            xs={{ span: 24 }}
                                            md={{ span: 14 }}
                                        >
                                            <div className="service__item-content__left">
                                                <div className="">
                                                    <h2>
                                                        MOOKSHYA SEARCH ENGINE
                                                    </h2>
                                                    <p>
                                                        ke taking part in
                                                        challenges where each
                                                        rider has a different
                                                        level and riding on a
                                                        different terrain. So
                                                        you are competing
                                                    </p>
                                                    <Link
                                                        href=""
                                                        to={"/"}
                                                        className="hover-e1"
                                                    >
                                                        <span className="border-left"></span>
                                                        <span className="border-right"></span>
                                                        <span className="border-top"></span>
                                                        <span className="border-bottom"></span>
                                                        Learn More
                                                    </Link>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col
                                            xs={{ span: 24 }}
                                            md={{ span: 10 }}
                                        >
                                            <div className="service__item-content__right">
                                                <img src={website} alt="" />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </TabPane>
                            <TabPane
                                tab={
                                    <div className="title">
                                        <span>MOBILE APP</span>
                                    </div>
                                }
                                key="3"
                            >
                                <div className="service__item-content">
                                    <Row gutter={[32, 32]}>
                                        <Col
                                            xs={{ span: 24 }}
                                            md={{ span: 14 }}
                                        >
                                            <div className="service__item-content__left">
                                                <div className="">
                                                    <h2>
                                                        MOOKSHYA SEARCH ENGINE
                                                    </h2>
                                                    <p>
                                                        ke taking part in
                                                        challenges where each
                                                        rider has a different
                                                        level and riding on a
                                                        different terrain. So
                                                        you are competing
                                                    </p>
                                                    <Link
                                                        href=""
                                                        to={"/"}
                                                        className="hover-e1"
                                                    >
                                                        <span className="border-left"></span>
                                                        <span className="border-right"></span>
                                                        <span className="border-top"></span>
                                                        <span className="border-bottom"></span>
                                                        Learn More
                                                    </Link>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col
                                            xs={{ span: 24 }}
                                            md={{ span: 10 }}
                                        >
                                            <div className="service__item-content__right">
                                                <img src={app} alt="" />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </TabPane>
                            <TabPane
                                tab={
                                    <div className="title">
                                        <span>WEB APP</span>
                                    </div>
                                }
                                key="4"
                            >
                                <div className="service__item-content">
                                    <Row gutter={[32, 32]}>
                                        <Col
                                            xs={{ span: 24 }}
                                            md={{ span: 14 }}
                                        >
                                            <div className="service__item-content__left">
                                                <div className="">
                                                    <h2>
                                                        MOOKSHYA SEARCH ENGINE
                                                    </h2>
                                                    <p>
                                                        ke taking part in
                                                        challenges where each
                                                        rider has a different
                                                        level and riding on a
                                                        different terrain. So
                                                        you are competing
                                                    </p>
                                                    <Link
                                                        href=""
                                                        to={"/"}
                                                        className="hover-e1"
                                                    >
                                                        <span className="border-left"></span>
                                                        <span className="border-right"></span>
                                                        <span className="border-top"></span>
                                                        <span className="border-bottom"></span>
                                                        Learn More
                                                    </Link>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col
                                            xs={{ span: 24 }}
                                            md={{ span: 10 }}
                                        >
                                            <div className="service__item-content__right">
                                                <img src={system} alt="" />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </TabPane>
                        </Tabs>
                    </div>

                    <div className="ourWork__tab-wrapper ourWork--mobile ">
                        <Tabs defaultActiveKey="1">
                            <TabPane
                                tab={
                                    <div className="tab-title">
                                        <span>UI/UX DESIGN</span>
                                    </div>
                                }
                                key="1"
                            >
                                <div className="service__item-content">
                                    <Row gutter={[32, 32]}>
                                        <Col
                                            xs={{ span: 24 }}
                                            md={{ span: 14 }}
                                        >
                                            <div className="service__item-content__left">
                                                <div className="">
                                                    <h2>
                                                        MOOKSHYA SEARCH ENGINE
                                                    </h2>
                                                    <p>
                                                        ke taking part in
                                                        challenges where each
                                                        rider has a different
                                                        level and riding on a
                                                        different terrain. So
                                                        you are competing
                                                    </p>
                                                    <Link
                                                        href=""
                                                        to={"/"}
                                                        className="hover-e1"
                                                    >
                                                        <span className="border-left"></span>
                                                        <span className="border-right"></span>
                                                        <span className="border-top"></span>
                                                        <span className="border-bottom"></span>
                                                        Learn More
                                                    </Link>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col
                                            xs={{ span: 24 }}
                                            md={{ span: 10 }}
                                        >
                                            <div className="service__item-content__right">
                                                <img src={uiux} alt="" />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </TabPane>
                            <TabPane
                                tab={
                                    <div className="title">
                                        <span>WEBSITE</span>
                                    </div>
                                }
                                key="2"
                            >
                                <div className="service__item-content">
                                    <Row gutter={[32, 32]}>
                                        <Col
                                            xs={{ span: 24 }}
                                            md={{ span: 14 }}
                                        >
                                            <div className="service__item-content__left">
                                                <div className="">
                                                    <h2>
                                                        MOOKSHYA SEARCH ENGINE
                                                    </h2>
                                                    <p>
                                                        ke taking part in
                                                        challenges where each
                                                        rider has a different
                                                        level and riding on a
                                                        different terrain. So
                                                        you are competing
                                                    </p>
                                                    <Link
                                                        href=""
                                                        to={"/"}
                                                        className="hover-e1"
                                                    >
                                                        <span className="border-left"></span>
                                                        <span className="border-right"></span>
                                                        <span className="border-top"></span>
                                                        <span className="border-bottom"></span>
                                                        Learn More
                                                    </Link>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col
                                            xs={{ span: 24 }}
                                            md={{ span: 10 }}
                                        >
                                            <div className="service__item-content__right">
                                                <img src={website} alt="" />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </TabPane>
                            <TabPane
                                tab={
                                    <div className="title">
                                        <span>MOBILE APP</span>
                                    </div>
                                }
                                key="3"
                            >
                                <div className="service__item-content">
                                    <Row gutter={[32, 32]}>
                                        <Col
                                            xs={{ span: 24 }}
                                            md={{ span: 14 }}
                                        >
                                            <div className="service__item-content__left">
                                                <div className="">
                                                    <h2>
                                                        MOOKSHYA SEARCH ENGINE
                                                    </h2>
                                                    <p>
                                                        ke taking part in
                                                        challenges where each
                                                        rider has a different
                                                        level and riding on a
                                                        different terrain. So
                                                        you are competing
                                                    </p>
                                                    <Link
                                                        href=""
                                                        to={"/"}
                                                        className="hover-e1"
                                                    >
                                                        <span className="border-left"></span>
                                                        <span className="border-right"></span>
                                                        <span className="border-top"></span>
                                                        <span className="border-bottom"></span>
                                                        Learn More
                                                    </Link>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col
                                            xs={{ span: 24 }}
                                            md={{ span: 10 }}
                                        >
                                            <div className="service__item-content__right">
                                                <img src={app} alt="" />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </TabPane>
                            <TabPane
                                tab={
                                    <div className="title">
                                        <span>WEB APP</span>
                                    </div>
                                }
                                key="4"
                            >
                                <div className="service__item-content">
                                    <Row gutter={[32, 32]}>
                                        <Col
                                            xs={{ span: 24 }}
                                            md={{ span: 14 }}
                                        >
                                            <div className="service__item-content__left">
                                                <div className="">
                                                    <h2>
                                                        MOOKSHYA SEARCH ENGINE
                                                    </h2>
                                                    <p>
                                                        ke taking part in
                                                        challenges where each
                                                        rider has a different
                                                        level and riding on a
                                                        different terrain. So
                                                        you are competing
                                                    </p>
                                                    <Link
                                                        href=""
                                                        to={"/"}
                                                        className="hover-e1"
                                                    >
                                                        <span className="border-left"></span>
                                                        <span className="border-right"></span>
                                                        <span className="border-top"></span>
                                                        <span className="border-bottom"></span>
                                                        Learn More
                                                    </Link>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col
                                            xs={{ span: 24 }}
                                            md={{ span: 10 }}
                                        >
                                            <div className="service__item-content__right">
                                                <img src={system} alt="" />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </TabPane>
                        </Tabs>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OurWork;
